import type {UseQueryResult} from '@tanstack/react-query';
import {useQuery} from '@tanstack/react-query';
import useApiFetch from '@/components/MSAL/useApiFetch';
import type {ClientServiceTeam} from '@/types/ClientServiceTeam';
import {apiUrl} from '@/utils/api';

export const useGetAllTeams = () : UseQueryResult<ClientServiceTeam[]> => {
    const fetch = useApiFetch();

    return useQuery(['teams'], async ({signal}) => {
        const response = await fetch(
            apiUrl('/v1/scheduler/teams').toString(),
            {signal}
        );

        if (!response.ok) {
            throw new Error('Unable to fetch team records.');
        }

        return (await response.json()) as ClientServiceTeam[];
    });
};
